import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { validateStoredToken } from '../actions/authActions';
import { LoadingOverlay, Center, Text } from '@mantine/core';

const AppInitializer = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated, user, permissions = { loading: false, data: null, error: null } } = useSelector(state => state.auth);

  useEffect(() => {
    // Solo validar token si no hay usuario autenticado o si no hay permisos cargados
    if (!isAuthenticated || !user || !permissions.data) {
      dispatch(validateStoredToken());
    }
  }, [dispatch, isAuthenticated, user, permissions.data]);

  useEffect(() => {
    // Si el usuario está autenticado y tiene permisos cargados, redirigir
    // Solo redirigir si no estamos ya en /procesos-evaluacion para evitar loops
    if (isAuthenticated && user && permissions && permissions.data && !permissions.loading) {
      const currentPath = window.location.pathname;
      if (currentPath === '/' || currentPath === '/login') {
        navigate('/procesos-evaluacion');
      }
    }
  }, [isAuthenticated, user, permissions, navigate]);

  if (permissions.loading && (!isAuthenticated || !user || !permissions.data)) {
    return (
      <Center style={{ height: '100vh' }}>
        <LoadingOverlay
          visible={true}
          zIndex={1000}
          overlayProps={{ radius: 'sm', blur: 2 }}
          loaderProps={{ color: '#e72166', type: 'bars' }}
        />
      </Center>
    );
  }

  return children;
};

export default AppInitializer;
